// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* sliderInput.css */

.slider-container {
    position: relative;
    width: 100%;
}

.slider-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: auto;
}

.slider-input-wrapper-wrapper{
    width: 100%;
    padding: 10px;
}

.slider-input-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    background-color: #F6F7F9;
    padding: 0px;
    border-radius: 100px;
    transition: all 0.3s ease;
}

.slider-input-wrapper:hover {
    background-color: #d3e0fa;
}

.slider-labels{
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 0px;
    -webkit-user-select: none;
            user-select: none;
}

.slider {
    width: calc(100% - 4px);
    appearance: none;
    background-color: rgba(211, 211, 211, 0);
    height: 12px;
    outline: none;
    box-sizing: content-box;
    cursor: pointer;
}

.slider-thumb {
    appearance: none;
    background-color: #6294AA;
    height: 25px;
    width: 25px;
    transform: translateY(-25%);
    border-radius: 50%;
    cursor: pointer;
    outline: none;
}

.slider-value {
    width: 10%;
    margin-left: 10px;
    font-size: 16px;
    font-weight: bold;
    float: right;
    vertical-align: middle;
}


.slider-value-input{
    width: 150px;
    height: 60px;
    display: flex;
    align-items: center;
}

.slider-value-input input {
    width: 100%!important;
    height: 50px!important;
    -moz-appearance: textfield; /* Firefox */
    padding-left: '10px';
    float: 'right';
    background-color: #F6F7F9;
    color: #464646;
    border: none;
    text-align: center!important;
    border-radius: 6px;
    font-size: 16px;
    margin-bottom: 0px!important;
}

.slider-value-input input:hover {
    background-color: #d3e0fa;
}

.slider-value-input input::-webkit-outer-spin-button,
.slider-value-input input::-webkit-inner-spin-button {
    -webkit-appearance: none; /* Chrome, Safari, Edge, Opera */
    margin: 0;
}

.radio-slider-wrapper {
    width: 100%;
    overflow-x: hidden;
}

.radio-button-container {
    display: flex;
    gap: 10px;
    padding: 0;
    overflow-x: auto;
}

.radio-button {
    flex: 0 0 auto;
    display: flex;
    padding: 0 10px;
    background-color: #F6F7F9;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.3s ease;
    white-space: nowrap;
    width: 17vw;
    height: 50px;
    justify-content: center;
    align-items: center;
}

.radio-button.selected {
    background-color: #6294AA;
    color: white;
}`, "",{"version":3,"sources":["webpack://./src/sliderInput.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,kBAAkB;IAClB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,wCAAwC;IACxC,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;AAC1B;;;AAGA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,0BAA0B,EAAE,YAAY;IACxC,oBAAoB;IACpB,cAAc;IACd,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,4BAA4B;IAC5B,kBAAkB;IAClB,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,wBAAwB,EAAE,gCAAgC;IAC1D,SAAS;AACb;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB","sourcesContent":["/* sliderInput.css */\n\n.slider-container {\n    position: relative;\n    width: 100%;\n}\n\n.slider-wrapper {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    height: auto;\n}\n\n.slider-input-wrapper-wrapper{\n    width: 100%;\n    padding: 10px;\n}\n\n.slider-input-wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    background-color: #F6F7F9;\n    padding: 0px;\n    border-radius: 100px;\n    transition: all 0.3s ease;\n}\n\n.slider-input-wrapper:hover {\n    background-color: #d3e0fa;\n}\n\n.slider-labels{\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    margin-bottom: 0px;\n    user-select: none;\n}\n\n.slider {\n    width: calc(100% - 4px);\n    appearance: none;\n    background-color: rgba(211, 211, 211, 0);\n    height: 12px;\n    outline: none;\n    box-sizing: content-box;\n    cursor: pointer;\n}\n\n.slider-thumb {\n    appearance: none;\n    background-color: #6294AA;\n    height: 25px;\n    width: 25px;\n    transform: translateY(-25%);\n    border-radius: 50%;\n    cursor: pointer;\n    outline: none;\n}\n\n.slider-value {\n    width: 10%;\n    margin-left: 10px;\n    font-size: 16px;\n    font-weight: bold;\n    float: right;\n    vertical-align: middle;\n}\n\n\n.slider-value-input{\n    width: 150px;\n    height: 60px;\n    display: flex;\n    align-items: center;\n}\n\n.slider-value-input input {\n    width: 100%!important;\n    height: 50px!important;\n    -moz-appearance: textfield; /* Firefox */\n    padding-left: '10px';\n    float: 'right';\n    background-color: #F6F7F9;\n    color: #464646;\n    border: none;\n    text-align: center!important;\n    border-radius: 6px;\n    font-size: 16px;\n    margin-bottom: 0px!important;\n}\n\n.slider-value-input input:hover {\n    background-color: #d3e0fa;\n}\n\n.slider-value-input input::-webkit-outer-spin-button,\n.slider-value-input input::-webkit-inner-spin-button {\n    -webkit-appearance: none; /* Chrome, Safari, Edge, Opera */\n    margin: 0;\n}\n\n.radio-slider-wrapper {\n    width: 100%;\n    overflow-x: hidden;\n}\n\n.radio-button-container {\n    display: flex;\n    gap: 10px;\n    padding: 0;\n    overflow-x: auto;\n}\n\n.radio-button {\n    flex: 0 0 auto;\n    display: flex;\n    padding: 0 10px;\n    background-color: #F6F7F9;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    white-space: nowrap;\n    width: 17vw;\n    height: 50px;\n    justify-content: center;\n    align-items: center;\n}\n\n.radio-button.selected {\n    background-color: #6294AA;\n    color: white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
